import CartItem from "./CartItem";
import {DateTime} from "luxon";

class EventItem extends CartItem {

    constructor(item, amount = 1, priceOption) {
        super(item, amount);
        this.insuranceAmount = 0;
        this.priceOption = priceOption;
    }
}

export default EventItem
